import posthog from 'posthog-js';
import { withChartProperties } from './chartIdentity';
import { bootstrapChartsAttribution, captureLandingContext } from './chartsSession';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const POSTHOG_ENABLED = process.env.REACT_APP_POSTHOG_ENABLED === 'true';

// 3 hours covers lunch without splitting a full 9am–4pm session.
const SESSION_IDLE_TIMEOUT_SECONDS = Number(
  process.env.REACT_APP_POSTHOG_SESSION_IDLE_TIMEOUT ?? '10800'
);

export const isPostHogEnabled = POSTHOG_ENABLED && Boolean(POSTHOG_KEY);

if (isPostHogEnabled) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: { path: true, search: true },
    capture_pageleave: true,
    autocapture: false,
    before_send: withChartProperties,
    disable_session_recording: true,
    session_idle_timeout_seconds: SESSION_IDLE_TIMEOUT_SECONDS,
  });
}

if (typeof window !== 'undefined') {
  bootstrapChartsAttribution(isPostHogEnabled ? posthog : null);
  captureLandingContext();
}

export default posthog;
